import { IconButton, Badge, Popover } from "@mui/material";
import { useContext, useState, useEffect } from "react";
import MainContext from "../../context/mainContext";
import notificationsService from "../../services/notifications.service";
import NotificationsIcon from "@mui/icons-material/Notifications";
import styles from "./Notifications.module.scss";
import NotificationList from "./NotificationList";

const Notifications: React.FC = () => {
  const timerInterval = 30000;
  const { currentUser } = useContext(MainContext);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [unreadNotifications, setUnreadNotifications] = useState<number>(0);

  const refreshNotifications = () => {
    notificationsService.countUnread().then((count) => {
      setUnreadNotifications(count);
    });
  };

  useEffect(() => {
    refreshNotifications();

    const notificationsTimer = setInterval(() => {
      refreshNotifications();
    }, timerInterval);

    return () => {
      if (notificationsTimer) {
        clearInterval(notificationsTimer);
      }
    };
  }, [currentUser]);

  const handleToggleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    toggleMenu(event.currentTarget);
  };

  const toggleMenu = (anchorElement: HTMLButtonElement | null) => {
    setIsOpen(!isOpen);
    setAnchorEl(anchorElement);
  };

  const handleOnChange = (close: boolean) => {
    refreshNotifications();

    if (close) setIsOpen(false);
  };

  return (
    <>
      <IconButton
        className={styles.notificationIcon}
        aria-label={`show ${unreadNotifications} new notifications`}
        color="primary"
        onClick={handleToggleMenu}
      >
        <Badge badgeContent={unreadNotifications} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>
      <Popover
        className={styles.notificationPopover}
        open={isOpen}
        anchorEl={anchorEl}
        onClose={() => toggleMenu(null)}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <NotificationList isOpen={isOpen} handleOnChange={handleOnChange} />
      </Popover>
    </>
  );
};

export default Notifications;
